module.exports = __webpack_public_path__ + "img/javier.474dc76d.jpg";